module.exports = __webpack_public_path__ + "img/0-23.40aae219.gif";